import { Response } from '@marketplace-web/core-api/api-client-util'

import { SellerBadgeDto, SellerBadgeModel, SellerBadgesResp } from '../types/seller-badge'

export const transformSellerBadgeDto = ({
  type,
  progress: { current, goal },
}: SellerBadgeDto): SellerBadgeModel => ({
  type,
  progress: { current, goal },
})

export const transformSellerBadgesResponse = (response: Response<SellerBadgesResp>) =>
  response.badges.map(transformSellerBadgeDto)
